import Svg, { Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgChevronRight = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 15 26" {...props}><Path fill="currentColor" fillRule="evenodd" d="M2.308 26 15 13 2.308 0 0 2.364 10.385 13 0 23.636 2.308 26Z" clipRule="evenodd" /></Svg>;
const Memo = memo(SvgChevronRight);
export default Memo;